// extracted by mini-css-extract-plugin
export var root = "styles-module--root--A4hKE";
export var link = "styles-module--link--1954x";
export var linkText = "styles-module--link-text--gQz5M";